import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "bevelandembosssetting"
    }}>{`BevelAndEmbossSetting`}</h1>
    <p>{`Bevel and emboss effect settings.`}</p>
    <h2 {...{
      "id": "instance"
    }}>{`Instance`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`isValid`}</strong>{` `}</p>
      <p parentName="blockquote">{`Returns true if the object specifier resolves to valid objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`parent`}</strong>{` `}</p>
      <p parentName="blockquote">{`The parent of the BevelAndEmbossSetting (a TransparencySetting, StrokeTransparencySetting, FillTransparencySetting or ContentTransparencySetting).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Events `}<strong parentName="p">{`events`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of events.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`EventListeners `}<strong parentName="p">{`eventListeners`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of event listeners.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`applied`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, the bevel or emboss effect is applied.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`BevelAndEmbossStyle `}<strong parentName="p">{`style`}</strong>{` `}</p>
      <p parentName="blockquote">{`The style of bevel or emboss.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`BevelAndEmbossTechnique `}<strong parentName="p">{`technique`}</strong>{` `}</p>
      <p parentName="blockquote">{`The edging technique of the bevel or emboss.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`depth`}</strong>{` `}</p>
      <p parentName="blockquote">{`The depth of the bevel or emboss (as a percentage). (Range: 0 to 1000)`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`BevelAndEmbossDirection `}<strong parentName="p">{`direction`}</strong>{` `}</p>
      <p parentName="blockquote">{`The direction of the bevel or emboss.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`size`}</strong>{` `}</p>
      <p parentName="blockquote">{`The size of the bevel or emboss.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`soften`}</strong>{` `}</p>
      <p parentName="blockquote">{`The amount (in pixels) of softening.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`angle`}</strong>{` `}</p>
      <p parentName="blockquote">{`The angle of the light source. (Range: -180 to 180)`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`altitude`}</strong>{` `}</p>
      <p parentName="blockquote">{`The altitude of the light source. (Range: 0 to 90)`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`useGlobalLight`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, the global light source is used.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Swatch `}<strong parentName="p">{`highlightColor`}</strong>{` `}</p>
      <p parentName="blockquote">{`The color applied to the highlight portion of the effect, specified as a swatch (color, gradient, tint, or mixed ink), a color library color, a hex value, or as an array of color values. The color mode dictates the array values: for RGB, specify three values, each in the range 0 to 255, in the format `}{`[R,G,B]`}{`; for CMYK, specify four values, each as a percentage and each in the range 0 to 100, in the format `}{`[C,M,Y,K]`}{`; for LAB, specify three values in the format `}{`[L,A,B]`}{`, with L in the range 0 to 100 and A and B in the range -128 to 127; for HSB, specify three colors in the format `}{`[H,S,B]`}{`, with H in the range 0 to 360 and S and B as percentages in the range 0 to 100.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`BlendMode `}<strong parentName="p">{`highlightBlendMode`}</strong>{` `}</p>
      <p parentName="blockquote">{`The blending mode for the highlight portion of the effect.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`highlightOpacity`}</strong>{` `}</p>
      <p parentName="blockquote">{`The opacity of the highlight portion of the effect (as a percentage). (Range: 0 to 100)`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Swatch `}<strong parentName="p">{`shadowColor`}</strong>{` `}</p>
      <p parentName="blockquote">{`The color applied to the shadow portion of the effect, specified as a swatch (color, gradient, tint, or mixed ink), a color library color, a hex value, or as an array of color values. The color mode dictates the array values: for RGB, specify three values, each in the range 0 to 255, in the format `}{`[R,G,B]`}{`; for CMYK, specify four values, each as a percentage and each in the range 0 to 100, in the format `}{`[C,M,Y,K]`}{`; for LAB, specify three values in the format `}{`[L,A,B]`}{`, with L in the range 0 to 100 and A and B in the range -128 to 127; for HSB, specify three colors in the format `}{`[H,S,B]`}{`, with H in the range 0 to 360 and S and B as percentages in the range 0 to 100.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`BlendMode `}<strong parentName="p">{`shadowBlendMode`}</strong>{` `}</p>
      <p parentName="blockquote">{`The blending mode for the shadow portion of the effect.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`shadowOpacity`}</strong>{` `}</p>
      <p parentName="blockquote">{`The opacity of the shadow portion of the effect (as a percentage). (Range: 0 to 100)`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`properties`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that allows setting of several properties at the same time.`}</p>
    </blockquote>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <blockquote>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Generates a string which, if executed, will return the BevelAndEmbossSetting.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`BevelAndEmbossSetting `}<strong parentName="p">{`getElements`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Resolves the object specifier, creating an array of object references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSpecifier`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Retrieves the object specifier.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EventListener `}<strong parentName="p">{`addEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Adds an event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`removeEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Removes the event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-1"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      